import { Box, Text, Title } from "@mantine/core";
import { useCsvContext } from "../context/CsvContext";

export const InfoSection = () => {
  const { serverResponse } = useCsvContext();

  return (
    <Box
      mt="lg"
      p="md"
      mb="xs"
      style={{ border: "1px solid #e0e0e0", borderRadius: "8px" }}
    >
      <Title order={3} mb={"lg"}>
        실시간 응답성
      </Title>
      <Text size="sm" color="dimmed">
        전송시각: {serverResponse?.transmissionTime ?? "00:00:00"}
      </Text>
      <Text size="sm" color="dimmed">
        응답시각: {serverResponse?.responseTime ?? "00:00:00"}
      </Text>
      <Text size="sm" color="dimmed" fw={900}>
        소요시간: {serverResponse?.duration ?? "0 ms"}
      </Text>
      <Text size="md" align="right">
        <strong>분류 결과 :</strong> {serverResponse?.predictProduct ?? "-"}
        &nbsp; &nbsp;
        <strong>정확도 :</strong>{" "}
        {serverResponse?.predictScore
          ? `${(Number(serverResponse.predictScore) * 100).toFixed(2)}%`
          : "-"}
      </Text>
    </Box>
  );
};
